import {
  ViewSection,
  ViewSectionContent,
  ViewSectionHeader,
  ViewSectionTitle,
} from '@fortem-monorepo/react-spa'
import { ICGG2Report } from '@fortem-monorepo/web-sdk'

import { ContentBlocks } from '@/components/content-blocks/ContentBlocks'
import { IC_GUIDELINES_DATA_GRID_OVERRIDES } from '@/pages/funds/ic-guidelines-v2/content-block-config'

export interface ProtectionStageProps {
  output: ICGG2Report.NormalStageOutput
}

export const ProtectionStage: React.FC<ProtectionStageProps> = ({ output }) => {
  const blocks = output.blocks ?? []

  if (!blocks.length) {
    return null
  }

  return (
    <ViewSection>
      <ViewSectionHeader>
        <ViewSectionTitle>Protection</ViewSectionTitle>
      </ViewSectionHeader>
      <ViewSectionContent className={'space-y-4'}>
        <ContentBlocks blocks={blocks} dataGridOverrides={IC_GUIDELINES_DATA_GRID_OVERRIDES} />
      </ViewSectionContent>
    </ViewSection>
  )
}
